import type { FaireProductEntity } from "../../entity_types/product";

export const p_mgjtx3u5nd: FaireProductEntity = {
  token: "p_mgjtx3u5nd",
  type: "product",
  name: "Dubai Chocolate Truffle",
  brandToken: "b_4tkquuuvuh",
  brandName: "The Chocolate Shoppe",
  imageUrl:
    "https://cdn.faire.com/fastly/2497536bfb87d1929e3826cf036501cbdcf3bb677753223f095a9c77c4486b6d.jpeg",
  galleryImageUrls: [],
  priceDollars: 2.08,
  description:
    "Inspired by the viral “Dubai chocolate” sensation, our Dubai Chocolate Truffle is a luxurious, modern confection that blends Belgian chocolate craftsmanship with Middle Eastern–inspired flavors.\n\nEach truffle features a silky pistachio-forward ganache, enriched with real pistachios and hazelnuts for natural depth and texture. The filling is delicately balanced with a touch of fleur de sel and wrapped in smooth Belgian milk chocolate, creating a rich yet refined bite that’s indulgent without being heavy.\n\nFinished with a subtle pistachio garnish, this truffle delivers a creamy, nutty profile with gentle sweetness and a sophisticated finish. It’s a standout piece for retailers seeking on-trend flavors with lasting appeal — elegant, distinctive, and unmistakably indulgent. \n\nAvailable in a case of 30 bulk pieces for candy counters, domed platters, or for packaging in your own boxes.",
  tags: [],
  msrpDollars: 4.16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:50:01.193Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
